<template>
    <div class="componentsCtn_1">
        <div class="top">
            我的消息（{{unreadCount}}未读）
            <span @click="markAsRead()" style="float:right;font-size: 16px;color: #C49760;font-weight: 300;margin-right: 57px;cursor:pointer;">全部标记为已读</span>
        </div>
        <div class="signUp_content">
            <div v-for="item in dataList" :key="item.id" :class="item.status=='0' ? 'signUp_item_banner2':'signUp_item_banner'">
                <div v-if="item.status=='0'" class="messageTip" style="top:70px;left:20px;">

                </div>
                <table>
                    <tr style="font-size: 14px;color: #979797;font-weight: 400;height: 28px;">
                        <td width="580px" style="vertical-align: text-top">消息内容</td>
                        <td width="240px" style="vertical-align: text-top">发送时间</td>
                        <td width="150px" style="vertical-align: text-top">操作</td>
                    </tr>
                    <tr style="height: 50px;font-size: 16px;" >
                        <td  style="vertical-align: text-top;width:425px;word-break: break-all;word-wrap:break-word;color: #3A3A3A;font-size: 16px;padding-right: 15px;">
                            {{item.content}}
                        </td>
                        <td style="vertical-align: text-top">
                            {{item.createTime}}
                        </td>
                        <td style="vertical-align: text-top;color: #C49760;cursor:pointer">
                            <span v-if="item.status=='0'">
                                <span @click="markAsRead_id(item.id)" v-if="item.type=='0'">
                                    标记为已读
                                </span>
                                <span @click="markAsRead_id(item.id)" v-if="item.type=='1'">
                                    标记为已读
                                </span>
                                <span @click="markAsRead_id(item.id)" v-if="item.type=='5'">
                                    标记为已读
                                </span>
                                <span @click="markAsRead_id(item.id);$router.push({path:'/signInContent',query:{'type':1}})" v-if="item.type=='2'">
                                    重新报名
                                </span>
                                <span @click="markAsRead_id(item.id);$router.push({path:'/courseShow',query:{'courseId':item.courseId,'commentId':item.commentId,'pageShow':2}})" v-if="item.type=='3'">
                                    点击查看
                                </span>
                                <span @click="markAsRead_id(item.id);$router.push({path:'/courseShow',query:{'courseId':item.courseId}})" v-if="item.type=='4'">
                                    回顾
                                </span>
                                <span @click="markAsRead_id(item.id);$router.push('/graduationCertificate');" v-if="item.type=='6'">
                                    申请证书
                                </span>
                                <span @click="markAsRead_id(item.id);$router.push('/graduationCertificate');" v-if="item.type=='7'">
                                    查看详情
                                </span>
                                <span @click="markAsRead_id(item.id);$router.push('/graduationCertificate');" v-if="item.type=='8'">
                                    查看详情
                                </span>
                                <span @click="markAsRead_id(item.id);$router.push('/excellentRecognition');" v-if="item.type=='9'">
                                    查看详情
                                </span>
                            </span>
                            <span v-if="item.status=='1'">
                                <span v-if="item.type=='0'" style="color:#979797">
                                    已读
                                </span>
                                <span v-if="item.type=='1'" style="color:#979797 ">
                                    已读
                                </span>
                                <span v-if="item.type=='5'" style="color:#979797 ">
                                    已读
                                </span>
                                <span @click="$router.push({path:'/signInContent',query:{'type':1}});" v-if="item.type=='2'">
                                    重新报名
                                </span>
                                <span @click="$router.push({path:'/courseShow',query:{'courseId':item.courseId,'commentId':item.commentId,'pageShow':2}})" v-if="item.type=='3'">
                                    点击查看
                                </span>
                                <span @click="$router.push({path:'/courseShow',query:{'courseId':item.courseId}})" v-if="item.type=='4'">
                                    回顾
                                </span>
                                <span @click="$router.push('/graduationCertificate');" v-if="item.type=='6'">
                                    申请证书
                                </span>
                                <span @click="$router.push('/graduationCertificate');" v-if="item.type=='7'">
                                    查看详情
                                </span>
                                <span @click="$router.push('/graduationCertificate');" v-if="item.type=='8'">
                                    查看详情
                                </span>
                                <span @click="$router.push('/excellentRecognition');" v-if="item.type=='9'">
                                    查看详情
                                </span>
                            </span>
                        </td>
                    </tr>
                </table>
            </div>
        </div>
    </div>

    
</template>

<script>
    export default {
        name: "message",
        data(){
            return{
                dataList:[],
                unreadCount:0,

            }
        },
        methods:{
            getKey() {
                return localStorage.getItem("token");
            },
            getSignUpData:function () {
                let that=this
                this.axios
                    .get("/learn_back/course/message/queryUserMessageList", {
                        headers: {
                            Authorization: "Bearer " + this.getKey(),
                        },
                    }).then((response) => {
                    console.log('我的消息')
                    console.log(response)
                    if(response.status==200){
                        that.dataList=response.data.data.pageList.records;
                        that.unreadCount=response.data.data.messageUnreadCount;
                    }
                })
            },
            markAsRead:function () {
                let that=this
                this.axios.post("/learn_back/course/message/sendMessageStatus", {
                        headers: {
                            Authorization: "Bearer " + this.getKey(),
                        },
                    }).then((response) => {
                    console.log('标记为已读')
                    console.log(response)
                    that.getSignUpData();
                    location.reload();
                })
            },
            markAsRead_id:function (data) {
                let that=this
                let param = new FormData();
                param.append("id", data);
                this.axios.post("/learn_back/course/message/sendMessageStatus",param, {
                    headers: {
                        Authorization: "Bearer " + this.getKey(),
                    },
                }).then((response) => {
                    console.log('标记为已读')
                    console.log(response)
                    that.getSignUpData();
                    location.reload();
                })
            },


        },
        mounted(){
            this.getSignUpData();

        }
    }
</script>

<style scoped>
    .messageTip{
        position:absolute;
        width: 6px;
        height: 6px;
        background: #FF4040;
        border-radius: 3px;
    }
    .signUp_item_banner{
        position:relative;
        width: 1032px;
        height: 122px;
        background: #F7F7F7;
        border-radius: 16px;
        margin-bottom: 20px;
        padding-top:31px;
        padding-left:39px;
    }
    .signUp_item_banner2{
        position:relative;
        width: 1032px;
        height: 122px;
        background: rgba(196,151,96,0.1);
        border-radius: 16px;
        margin-bottom: 20px;
        padding-top:31px;
        padding-left:39px;
    }
    .signUp_content{
        width: 100%;
        height: 576px;
        padding-left: 35px;
        overflow-y: auto;
    }
    /*滚动条样式*/
    .signUp_content::-webkit-scrollbar {
        width: 4px;
    }
    .signUp_content::-webkit-scrollbar-thumb {
        border-radius: 10px;
        box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
        background: rgba(0,0,0,0.2);
    }
    .signUp_content::-webkit-scrollbar-track {
    }
    .top{
        height: 84px;
        line-height: 84px;
        padding-left: 35px;
        padding-right:37px;
        font-size: 20px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #3A3A3A;
    }
    .componentsCtn_1{
        width: 100%;
        height: 660px;
        background: #FFFFFF;
        border-radius: 16px;
    }

</style>